import { render, staticRenderFns } from "./previewPaper.vue?vue&type=template&id=e41988e0&scoped=true"
import script from "./previewPaper.vue?vue&type=script&lang=js"
export * from "./previewPaper.vue?vue&type=script&lang=js"
import style0 from "./previewPaper.vue?vue&type=style&index=0&id=e41988e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41988e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e41988e0')) {
      api.createRecord('e41988e0', component.options)
    } else {
      api.reload('e41988e0', component.options)
    }
    module.hot.accept("./previewPaper.vue?vue&type=template&id=e41988e0&scoped=true", function () {
      api.rerender('e41988e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/previewPaper.vue"
export default component.exports